import React, { useState } from 'react';
import { isWechatBrowser } from '@/utils/downloadUtils';
import styled from 'styled-components';
import { CloseOutlined } from '@ant-design/icons';

const Banner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: #fffbe6;
  border-bottom: 1px solid #ffe58f;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  color: #614700;
`;

const CloseBtn = styled.button`
  position: absolute;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  color: #614700;
  padding: 4px;
  display: flex;
  align-items: center;
  font-size: 12px;
  opacity: 0.6;
  &:hover {
    opacity: 1;
  }
`;

const WechatBrowserBanner: React.FC = () => {
  const [dismissed, setDismissed] = useState(() => {
    return sessionStorage.getItem('wechat_banner_dismissed') === '1';
  });

  if (!isWechatBrowser() || dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem('wechat_banner_dismissed', '1');
    setDismissed(true);
  };

  return (
    <Banner>
      <span>⚠️ 为了更好的体验，推荐使用 Chrome / Edge 浏览器</span>
      <CloseBtn onClick={handleDismiss}>
        <CloseOutlined />
      </CloseBtn>
    </Banner>
  );
};

export default WechatBrowserBanner;
